/**
 * The bag button's standard look (the Prints mockup's header `#bagBtn`,
 * `.icon-btn` and `.bag-count`), in theme tokens: the bag icon, its count, and
 * a small bump when an item goes in. Draws the behavior half's state and calls
 * its actions.
 */
import { useEffect, useRef, useState } from 'react';

import { partsOf, pieceRoot } from '../../contract/runtime';
import { contract } from './contract';
import type { ShopBagButtonRuntime } from './useShopBagButton';
import css from './ShopBagButton.module.css';

const part = partsOf(contract);

export function ShopBagButtonView({ state, actions }: ShopBagButtonRuntime) {
  const last = useRef(state.count);
  const [bump, setBump] = useState(0);
  useEffect(() => {
    if (state.count > last.current) setBump((n) => n + 1);
    last.current = state.count;
  }, [state.count]);

  if (!state.shown) return null;
  return (
    <button type="button" className={css.button} aria-label={state.label} onClick={actions.open} {...pieceRoot(contract)} {...part('button')}>
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M5 8h14l-1 12H6L5 8z" />
        <path d="M9 8V6a3 3 0 0 1 6 0v2" />
      </svg>
      {state.count > 0 && (
        <span key={bump} className={`${css.count} ${bump ? css.bump : ''}`} {...part('count')}>
          {state.count}
        </span>
      )}
    </button>
  );
}
